/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import List from './List';

import styles from '../../styles/lists/row-list.module.css';

const propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
        }),
    ),
    cardWidth: PropTypes.number,
    listRef: AppPropTypes.ref,
    itemsRef: AppPropTypes.ref,
    withoutScrollSnap: PropTypes.bool,
    className: PropTypes.string,
    itemsClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    cardClassName: PropTypes.string,
};

const defaultProps = {
    items: null,
    cardWidth: null,
    listRef: null,
    itemsRef: null,
    withoutScrollSnap: false,
    className: null,
    itemsClassName: null,
    itemClassName: null,
    cardClassName: null,
};

function RowList({
    items,
    cardWidth,
    listRef,
    itemsRef,
    withoutScrollSnap,
    className,
    itemsClassName,
    itemClassName,
    cardClassName,
    ...props
}) {
    return (
        <List
            {...props}
            ref={listRef}
            itemsRef={itemsRef}
            cardWidth={cardWidth}
            itemStyle={{
                maxWidth: cardWidth,
                minWidth: cardWidth,
            }}
            items={items}
            className={classNames([
                styles.container,
                'drag-disabled',
                {
                    [styles.scrollSnap]: !withoutScrollSnap,
                    [className]: className !== null,
                },
            ])}
            itemsClassName={classNames([
                styles.items,
                {
                    [itemsClassName]: itemsClassName !== null,
                },
            ])}
            itemClassName={classNames([
                styles.item,
                {
                    [itemClassName]: itemClassName !== null,
                },
            ])}
            cardClassName={classNames([
                styles.card,
                {
                    [cardClassName]: cardClassName !== null,
                },
            ])}
        />
    );
}

RowList.propTypes = propTypes;
RowList.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => <RowList listRef={ref} {...props} />);
